export { default } from './StorePageInfo';
